export const spaceshipListOption = {
  border: true,
  stripe: true,
  showSummary: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: true,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  column: [
    {
      label: '区域',
      prop: 'regionName'
    },
    {
      label: '市场',
      prop: 'marketName'
    },
    {
      label: '员工总数',
      prop: 'marketTotalNumber'
    },
    {
      label: '实际助力人数',
      prop: 'presentBoostedNumber'
    },
    {
      label: '助力百分比',
      prop: 'boostedValue',
      sortable: true,
      solt: true,
    },
  ]
}